<ng-sidebar-container>
  <div ng-sidebar-content [ngStyle]="{'margin-bottom': '61px'}">
<ngx-page-container>
  
  <div>
  <h1>{{ $any(editorUtil)?.title }}</h1>
  <hr>

  <ngx-loading-spinner [loading]="!editorItems?.[0] && utilType !== 'projectStatus'"></ngx-loading-spinner>

  <!-- ============================================== checklist editor ============================================ -->
  <!-- ============================================ changelog text editor ============================================ -->
  <!-- ============================================== file descriptions ============================================ -->
  <!-- ============================================== tax hint editor ============================================ -->
  <div *ngIf="utilType == 'checklist' || utilType == 'changelog' || utilType == 'fileDescriptions'" class="section">

    <div *ngFor="let item of editorItems">
      <h4>{{item?.name}}</h4>
      <ngx-form-text *ngIf="item" [multiline]="1" [(value)]="item.data"></ngx-form-text>
      <br />
    </div>

  </div>

  <!-- ============================================== display dates text ============================================ -->
  <div *ngIf="utilType == 'displayDatesStore' || utilType == 'taxHintStore'" class="section">
     
    <p>Line breaks: type 'Shift'+'Enter' for multi-line entries</p>

      <ngx-form-text [multiline]="1" [(value)]="editorItem" ></ngx-form-text>

  </div>
  
  <!-- ============================================ currency editor ============================================ -->
  <div *ngIf="utilType == 'currency'" class="section">

    <br>
    Exchange rate ( 1 EUR = )
    <br>
    <br>
    <button *ngIf="!editorUtil.data || !editorUtil.data.length" class="nrk-doc-button" (click)="addCurrencyRow(0)">+</button>
    <table class="nrk-table" *ngIf="editorUtil.data && editorUtil.data.length">
      <tr>
        <th></th><th></th><th *ngFor="let col of editorUtil.columns">{{col.name}}</th>
      </tr>
      <tr *ngFor="let row of editorUtil.data; index as idx">
        <td>
          <button class="nrk-doc-button" (click)="addCurrencyRow(idx)">+</button>
        </td>
        <td>
          <button class="nrk-doc-button" (click)="removeCurrencyRow(idx)">-</button>
        </td>
        <td *ngFor="let col of editorUtil.columns">
          <ngx-doc-form-date *ngIf="col.type === 'date'" class="fullwidth" [(value)]="row[col.id]"></ngx-doc-form-date>
          <ngx-doc-form-texfield *ngIf="col.type === 'number'" class="fullwidth" placeholder="Invoice" [(value)]="row[col.id]"></ngx-doc-form-texfield>
        </td>
      </tr>
    </table>

  </div>

  <!-- ============================================ hs code editor ============================================ -->
  <div *ngIf="utilType == 'hsCode'" class="section">

    <br>
    <button *ngIf="!editorUtil.data || !editorUtil.data.length" class="nrk-doc-button" (click)="addHsCodeRow(0)">+</button>
    <table class="nrk-table" *ngIf="editorUtil.data && editorUtil.data.length">
      <tr>
        <th></th><th></th><th>Type</th><th>HS Code</th><th>Description</th>
      </tr>
      <tr *ngFor="let row of editorUtil.data; index as idx">
        <td>
          <button class="nrk-doc-button" (click)="addHsCodeRow(idx)">+</button>
        </td>
        <td>
          <button class="nrk-doc-button" (click)="removeHsCodeRow(idx)">-</button>
        </td>
        <td>
          <ngx-doc-form-dropdown class="fullwidth" [(value)]="row['type']" [options]="[{id: 0, name: 'Energy'}, {id: 1, name: 'Electro'}]"></ngx-doc-form-dropdown>
        </td>
        <td>
          <ngx-doc-form-texfield class="fullwidth" placeholder="HS Code" [(value)]="row['code']"></ngx-doc-form-texfield>
        </td><td>
          <ngx-doc-form-texfield class="fullwidth" placeholder="Description" [(value)]="row['text']"></ngx-doc-form-texfield>
        </td>
      </tr>
    </table>

  </div>

  <!-- ============================================ fiscalYear editor ============================================ -->
  <div *ngIf="utilType == 'fiscalYear'" class="section">

    <table class="nrk-table fiscal-year">
      <thead>
        <tr><th>Doc #</th><th>Issue Date</th><th>Dispatch Date</th><th>Customer</th><th>Line Item</th><th>Fiscal Year</th><th>✓</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let inv of editorUtil.invoices">
          <td>{{inv.code}}</td>
          <td>{{inv.issueDate | date : 'yyyy-MM-dd'}}</td>
          <td>{{inv.vieDispatchDate | date : 'yyyy-MM-dd' }}</td>
          <td>{{inv.recipient?.name }}</td>
          <td>{{inv.lineItems[0]?.finishedProduct?.calcName}}</td>
          <td>
            <ngx-doc-form-dropdown [value]="inv.fiscalYear" [options]="$any(editorUtil).yearOptions" (valueChange)="$any(editorUtil).fiscalYearChanged(inv)"></ngx-doc-form-dropdown>
          </td>
          <td>{{$any(inv).updated ? '✓' : ''}}</td>
        </tr>
      </tbody>
    </table>

  </div>

  <!-- ============================================ legacy data editor ============================================ -->
  <div *ngIf="utilType == 'legacyData'" class="section">

    <ngx-loading-spinner [loading]="loadingLegacyData || editorUtil.loading"></ngx-loading-spinner>

    <button class="btn btn-success btn-sm" (click)="analyzeDeliveryNotes()">Analyze Delivery Notes / Status</button>
    <br />
    <button class="btn btn-primary btn-sm" [attr.disabled]="!$any(editorUtil).deliveryNotes?.length || null" (click)="$any(editorUtil).setAllProvedCompleted()">Set all with PoD completed</button>
    <div class="row" style="align-items:center;margin:0">
      <ngx-doc-form-date [(value)]="$any(editorUtil).earlierDate" [disabled]="!$any(editorUtil).deliveryNotes?.length || null"></ngx-doc-form-date>
      <div><button class="btn btn-primary btn-sm" [attr.disabled]="!$any(editorUtil).earlierDate || null" (click)="$any(editorUtil).setAllEarlierCompleted()">Set all prior to {{$any(editorUtil).earlierDate | date: 'yyyy-MM-dd'}} completed</button></div>
    </div>
    <table class="nrk-table" *ngIf="$any(editorUtil).deliveryNotes?.length">
      <tr><th>Code</th><!--<th>DN Dispatch Date</th>--><th>OC Dispatch Date</th><th>DN PoD</th><th>IN PoD</th><th>Packing Status</th><th class="pl-4">Set Packing Status</th></tr>
      <tr *ngFor="let dn of $any(editorUtil).deliveryNotes">
        <td>{{dn.code}}</td>
        <!-- <td>{{dn.vieDispatchDate | date : 'yyyy-MM-dd'}}</td> -->
        <td>{{dn.ocDispatch | date : 'yyyy-MM-dd'}}</td>
        <td>{{dn.proveOfDelivery?.files?.length || ''}}</td>
        <td>{{dn.invoicePoD?.files?.length || ''}}</td>
        <td [ngStyle]="{ 'background-color': packingData.color(dn.packingStatus)}">{{packingData.text(dn.packingStatus)}}</td>
        <td class="pl-4">
          <div style="cursor:pointer">
            <ng-container *ngFor="let status of [5,4,3,2,1,0]">
              <span [ngStyle]="{padding:'0.2rem','background-color': packingData.color(status)}" (click)="$any(editorUtil).setDnStatus(dn, status)">
                {{packingData.text(status)}}
              </span>
              &nbsp;
            </ng-container>
          </div>
        </td>
      </tr>
    </table>

    <hr />

    <button class="btn btn-success btn-sm" (click)="analyzeLegacyData()" [disabled]="true">Analyze Businesses</button>
    <table>
      <tr *ngFor="let name of customerNames">
        <td>{{name}}</td>
        <td style="width:25em"><ngx-doc-form-filter-select [(value)]="businessReference[name]" [options]="businessOptions"></ngx-doc-form-filter-select></td>
        <td class="h4">{{savedReference[name] ? '✓' : ''}}</td>
      </tr>
    </table>
  </div>

  <!-- ============================================ payment editor ============================================ -->

  <div *ngIf="utilType == 'paymentStore'" class="section">

    <div>
      <h4>{{$any(editorUtil).getSectionName('paymentPlanText')}}</h4>
      <table class="nrk-table">
        <tr>
          <th></th>
          <th></th>
          <th>Text</th>
        </tr>
        <tr *ngFor="let row of $any(editorUtil).paymentPlanText; index as idx">
          <td>
            <button class="nrk-button" (click)="$any(editorUtil).addRow('paymentPlanText', idx)">+</button>
          </td><td>
            <button class="nrk-button" (click)="$any(editorUtil).removeRow('paymentPlanText', idx)">-</button>
          </td>
          <td class="multiline-text"><ngx-form-text [multiline]="1" [(value)]="row.text"></ngx-form-text></td>
        </tr>
      </table>
    </div>

    <br><br>

    <div>
      <h4>{{$any(editorUtil).getSectionName('paymentText')}}</h4>
      <table class="nrk-table">
        <tr>
          <th></th>
          <th></th>
          <th>Text</th>
          <th>Report Date Field</th>
        </tr>
        <tr *ngFor="let row of $any(editorUtil).paymentText; index as idx">
          <td>
            <button class="nrk-button" (click)="$any(editorUtil).addRow('paymentText', idx)">+</button>
          </td><td>
            <button class="nrk-button" (click)="$any(editorUtil).removeRow('paymentText', idx)">-</button>
          </td>
          <td class="multiline-text"><ngx-form-text [multiline]="1" [(value)]="row.text"></ngx-form-text></td>
          <td><ngx-doc-form-dropdown class="fullwidth" [(value)]="row.reportField" [options]="$any(editorUtil).reportDateFieldOptions"></ngx-doc-form-dropdown></td>
        </tr>
      </table>
    </div>

    <br><br>

    <div>
      <h4>{{$any(editorUtil).getSectionName('termsOfPayment')}}</h4>
      <table class="nrk-table">
        <tr>
          <th></th>
          <th></th>
          <th>Text</th>
          <th>Days</th>
          <th title="End of Month">EOM</th>
          <th title="End of Month + days">+Days</th>
        </tr>
        <tr *ngFor="let row of $any(editorUtil).termsOfPayment; index as idx">
          <td>
            <button class="nrk-button" (click)="$any(editorUtil).addRow('termsOfPayment', idx)">+</button>
          </td><td>
            <button class="nrk-button" (click)="$any(editorUtil).removeRow('termsOfPayment', idx)">-</button>
          </td>
          <td class="multiline-text"><ngx-form-text [multiline]="1" [(value)]="row.text"></ngx-form-text></td>
          <td style="width:4em"><ngx-doc-form-texfield class="fullwidth" [(value)]="row.days"></ngx-doc-form-texfield></td>
          <td style="text-align: center"><ngx-doc-form-checkbox [(value)]="row.eom"></ngx-doc-form-checkbox></td>
          <td style="width:4em"><ngx-doc-form-texfield class="fullwidth" [(value)]="row.plusDays"></ngx-doc-form-texfield></td>
        </tr>
      </table>
    </div>

  </div>

  <!-- ============================================ business / terms of payment ============================================ -->

  <div *ngIf="utilType == 'businessToP'" class="section">

    <table class="nrk-table business-top">
      <tr><th>Business</th><th>Select</th><th>Payment Text</th><th>Select</th><th>Terms of Payment</th></tr>
      <tr *ngFor="let comp of $any(editorUtil).store.businesses">
        <td>{{comp.name}}</td>

        <td><ngx-doc-form-filter-select 
          [value]="$any(editorUtil).getField(comp, contactField.PaymentText)" 
          (valueChange)="$any(editorUtil).setField(comp, contactField.PaymentText, $event)"
          [options]="$any(editorUtil).store.paymentTextOptions">
        </ngx-doc-form-filter-select></td>
        <td><ngx-form-text 
          [multiline]="1" 
          [value]="$any(editorUtil).getField(comp, contactField.PaymentText)" 
          (valueChange)="$any(editorUtil).setField(comp, contactField.PaymentText, $event)">
        </ngx-form-text></td>

        <td><ngx-doc-form-filter-select 
          [value]="$any(editorUtil).getField(comp, contactField.PaymentConditions)" 
          (valueChange)="$any(editorUtil).setField(comp, contactField.PaymentConditions, $event)"
          [options]="$any(editorUtil).store.termsOfPaymentOptions">
        </ngx-doc-form-filter-select></td>
        <td><ngx-form-text 
          [multiline]="1" 
          [value]="$any(editorUtil).getField(comp, contactField.PaymentConditions)" 
          (valueChange)="$any(editorUtil).setField(comp, contactField.PaymentConditions, $event)">
        </ngx-form-text></td>
      </tr>
    </table>

    <!-- <td><ngx-doc-form-filter-select [(value)]="comp.tost" [options]="$any(editorUtil).store.termsOfPaymentOptions"></ngx-doc-form-filter-select></td>
    <td><ngx-form-text [multiline]="1" [(value)]="comp.tost"></ngx-form-text></td> -->
<!-- <ngx-doc-form-filter-select [noBorder]="true" title="Select terms of payment" (valueChange)="storeValueChanged(field.value, $event)" [options]="data.termsOfPaymentOptions"></ngx-doc-form-filter-select>
    <ngx-form-text [title]="field.title" [multiline]="1" [value]="getFieldValue(field.value)" (valueChange)="setFieldValue(field.value, $event)"></ngx-form-text> -->

  </div>

  <!-- ============================================ PFSPO availability editor ============================================ -->

  <div *ngIf="utilType == 'pfspoAvailability' && editorUtil.data?.spos" class="section">
    <table class="nrk-table">
      <tr>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('code')">Document #</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('recipient')">Recipient</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('customerReference')">Customer Reference</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('relatedCS')">CS</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('exwJapanDate')">EXW Date</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('arrivingVieDate')">ETA AT Date</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('product')">Product</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('quantity')">Quantity</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('availabilityStatus')">Availability status</th>
      </tr>
      <ng-container *ngFor="let code of $any(editorUtil).sort.codes">
        <tr *ngIf="$any(editorUtil).table[code]">
          <td>{{code}}</td>
          <td>{{$any(editorUtil).table[code].recipient}}</td>
          <td>{{$any(editorUtil).table[code].customerReference}}</td>
          <td>{{$any(editorUtil).table[code].relatedCS}}</td>
          <td style="width:6em">{{$any(editorUtil).table[code].exwJapanDate}}</td>
          <td style="width:6em">{{$any(editorUtil).table[code].arrivingVieDate}}</td>
          <td style="white-space:pre-wrap">{{$any(editorUtil).table[code].product}}</td>
          <td>{{$any(editorUtil).table[code].quantity}}</td>
          <td style="width:20em">
            <nb-radio-group [name]="'availability'+code" class="row ml-4" [(ngModel)]="$any(editorUtil).table[code].availabilityStatus">
              <!-- <nb-radio [value]="0">-</nb-radio> -->
              <nb-radio [value]="'1'" (valueChange)="$any(editorUtil).availabilityChanged(code, 1)">Not completed</nb-radio>
              <nb-radio [value]="'2'" (valueChange)="$any(editorUtil).availabilityChanged(code, 2)">Completed</nb-radio>
            </nb-radio-group>
          </td>
        </tr>
      </ng-container>
    </table>
  </div>

  <!-- ============================================ Project Status Editor ============================================ -->

  <div *ngIf="utilType == 'projectStatus' && editorUtil.data?.ocs" class="section">
    <table class="nrk-table">
      <tr>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('code')">Document #</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('recipient')">Recipient</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('customerReference')">Customer Reference</th>
        <!-- <th class="pseudo-link" (click)="$any(editorUtil).onSort('relatedCS')">CS</th> -->
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('dispatchDate')">Dispatch Date</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('etaDate')">ETA Customer</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('product')">Product</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('quantity')">Quantity</th>
        <th class="pseudo-link" (click)="$any(editorUtil).onSort('projectCompleted')">Project status</th>
      </tr>
      <ng-container *ngFor="let code of $any(editorUtil).sort.codes">
        <tr *ngIf="$any(editorUtil).table[code]">
          <td>{{code}}</td>
          <td>{{$any(editorUtil).table[code].recipient}}</td>
          <td>{{$any(editorUtil).table[code].customerReference}}</td>
          <!-- <td>{{$any(editorUtil).table[code].relatedCS}}</td> -->
          <td style="width:6em">{{$any(editorUtil).table[code].dispatchDate}}</td>
          <td style="width:6em">{{$any(editorUtil).table[code].etaDate}}</td>
          <td style="white-space:pre-wrap">{{$any(editorUtil).table[code].product}}</td>
          <td>{{$any(editorUtil).table[code].quantity}}</td>
          <td style="width:20em">
            <nb-radio-group [name]="'availability'+code" class="row ml-4" [(ngModel)]="$any(editorUtil).table[code].projectCompleted">
              <!-- <nb-radio [value]="0">-</nb-radio> -->
              <nb-radio [value]="false" (valueChange)="$any(editorUtil).projectStatusChanged(code, false)">Not completed</nb-radio>
              <nb-radio [value]="true" (valueChange)="$any(editorUtil).projectStatusChanged(code, true)">Completed</nb-radio>
            </nb-radio-group>
          </td>
        </tr>
      </ng-container>
    </table>
  </div>

  <!-- ============================================ Packing editor ============================================ -->

  <div *ngIf="utilType == 'packingStore'" class="section">

    <div>
      <h4>{{$any(editorUtil).getSectionName('palletDetails')}}</h4>

      Pallet
      <table class="nrk-table packing-store">
        <tr>
          <th></th><th colspan="2">▼▲</th><th></th><th>ID</th><th>Name</th><th>length (cm)</th><th>width (cm)</th><th>height (cm)</th><th>weight (kg)</th>
        </tr>
        <tr *ngFor="let row of $any(editorUtil).palletDetails; index as idx">
          <td style="width:auto"><button class="nrk-button" (click)="$any(editorUtil).addRow('palletDetails', row)">+</button></td>
          <td role="button" style="width:auto" (click)="moveDown($any(editorUtil).palletDetails, idx)">▼</td>
          <td role="button" style="width:auto" (click)="moveUp($any(editorUtil).palletDetails, idx)">▲</td>
          <!-- <td style="width:auto"><button *ngIf="canRemove('finalPacking', idx)"$any(editorUtil).palletDetails.length > 1" class="nrk-button" (click)="$any(editorUtil).removeRow('palletDetails', idx)">-</button></td> -->
          <td style="width:auto"><button *ngIf="$any(editorUtil).canRemove('palletDetails', row)" class="nrk-button" (click)="$any(editorUtil).removeRow('palletDetails', row)">-</button></td>
          <td><ngx-form-text [(value)]="row.id" [disabled]="!$any(editorUtil).canRemove('palletDetails', row)"></ngx-form-text></td>
          <td style="width:auto"><ngx-form-text [(value)]="row.name"></ngx-form-text></td>
          <td><ngx-form-text [(value)]="row.length" (valueChange)="$any(editorUtil).generateName(row, false)"></ngx-form-text></td>
          <td><ngx-form-text [(value)]="row.width" (valueChange)="$any(editorUtil).generateName(row, false)"></ngx-form-text></td>
          <td><ngx-form-text [(value)]="row.height"></ngx-form-text></td>
          <td><ngx-form-text [(value)]="row.weight"></ngx-form-text></td>
        </tr>
      </table>
      <br><br>
    </div>

    <div>
      <h4>{{$any(editorUtil).getSectionName('boxDetails')}}</h4>

      Carton Box
      <table class="nrk-table packing-store">
        <tr>
          <th></th><th></th><th colspan="2">▼▲</th><th></th><th>ID</th><th>Name</th><th>length (cm)</th><th>width (cm)</th><th>height (cm)</th><th>weight (kg)</th>
        </tr>
        <ng-container *ngFor="let row of $any(editorUtil).boxDetails; index as idx">
          <tr [ngStyle]="{ 'background-color': row.disabled ? '#e8e8e8' : null }">
            <td style="width:auto"><button class="nrk-button" (click)="row.disabled = !row.disabled">{{row.disabled ? 'o' : 'x'}}</button></td>
            <td style="width:auto"><button class="nrk-button" (click)="$any(editorUtil).addRow('boxDetails', row)">+</button></td>
            <td role="button" style="width:auto" (click)="moveDown($any(editorUtil).boxDetails, idx)">▼</td>
            <td role="button" style="width:auto" (click)="moveUp($any(editorUtil).boxDetails, idx)">▲</td>
            <!-- <td style="width:auto"><button *ngIf="$any(editorUtil).boxDetails.length > 1" class="nrk-button" (click)="$any(editorUtil).removeRow('boxDetails', idx)">-</button></td> -->
            <td style="width:auto"><button *ngIf="$any(editorUtil).canRemove('boxDetails', row)" class="nrk-button" (click)="$any(editorUtil).removeRow('boxDetails', row)">-</button></td>
            <td><ngx-form-text [(value)]="row.id" [disabled]="!$any(editorUtil).canRemove('boxDetails', row)" [disabled]="row.disabled"></ngx-form-text></td>
            <td style="width:auto"><ngx-form-text [(value)]="row.name" [disabled]="row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [(value)]="row.length" (valueChange)="$any(editorUtil).generateName(row, true)" [disabled]="row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [(value)]="row.width" (valueChange)="$any(editorUtil).generateName(row, true)" [disabled]="row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [(value)]="row.height" (valueChange)="$any(editorUtil).generateName(row, true)" [disabled]="row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [(value)]="row.weight" [disabled]="row.disabled"></ngx-form-text></td>
          </tr>
        </ng-container>
      </table>
      <br><br>
    </div>

    <!-- <div>
      <h4>{{$any(editorUtil).getSectionName('boxLayer')}}</h4>

      Max Box / layer
      <table class="nrk-table">
        <tr>
          <th>Pallet</th><th>Carton box</th><th>Boxes per layer</th><th>Max boxes per layer</th>
        </tr>
        <ng-container *ngFor="let row of $any(editorUtil).getBoxLayer()">
          <tr>                
            <td><ngx-form-text [multiline]="1" [(value)]="row.pallet"></ngx-form-text>{{$any(editorUtil).getPalletDims(row.pallet)}}</td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.cartonBox"></ngx-form-text>{{$any(editorUtil).getBoxDims(row.cartonBox)}}</td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.boxesPerLayer"></ngx-form-text><br></td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.maxLayers"></ngx-form-text><br></td>
          </tr>
        </ng-container>
          <tr *ngFor="let row of $any(editorUtil).boxLayer; index as idx">
            <td style="width:auto"><button class="nrk-button" (click)="$any(editorUtil).addRow('boxLayer', idx)">+</button></td>
            <td style="width:auto"><button *ngIf="$any(editorUtil).boxLayer.length > 1" class="nrk-button" (click)="$any(editorUtil).removeRow('boxLayer', idx)">-</button></td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.pallet"></ngx-form-text></td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.cartonBox"></ngx-form-text></td>
            <td><ngx-doc-form-dropdown [(value)]="row.pallet" [options]="palletOptions"></ngx-doc-form-dropdown></td>
            <td><ngx-doc-form-dropdown [(value)]="row.cartonBox" [options]="cartonBoxOptions"></ngx-doc-form-dropdown></td>
            <td><ngx-form-text [multiline]="1" [(value)]="row.boxesPerLayer"></ngx-form-text></td>
          </tr>
      </table>
      <br><br>
    </div>

    <div>
      <h4>Multiplyer</h4>
      Product net weight to Product Gross weight (%):
      <div style="display:inline-block;width:8rem;padding-left:1rem">
        <ngx-form-text [multiline]="1" [(value)]="$any(editorUtil).multiplier"></ngx-form-text>
      </div>
    </div> -->

    <div style="min-width:140rem;">
      <h4>{{$any(editorUtil).getSectionName('finalPacking')}}</h4>

      <button class="nrk-button my-2" (click)="exportToExcel(fpdTable)">Export to Excel</button>

      <table class="nrk-table" #fpdTable>
        <tr>
          <th></th>
          <th></th>
          <th colspan="2">▼▲</th>
          <th></th>
          <th>ID</th>
          <th>Name</th>
          <th>Pallet</th>
          <th>Carton box</th>
          <th>Boxes per layer</th>
          <th>Layers per pallet</th>
          <th>Multiplier (%)</th>
          <th>Height adjustment (cm)</th>
          <th colspan="2">Temperature sticker (T) / Weight (kg)</th>
          <th colspan="2">Thermo shield (TS) / Weight (kg)</th>
          <th colspan="2">Edge protection (EP) / Weight (kg)</th>
          <th>NRKA relabelling (RL)</th>
          <th>Add Box Label to outside of packing</th>
          <th>Text</th>
          <th>Free text</th>
        </tr>
        <tr>
          <th colspan="4"><button class="nrk-button" (click)="filterField = {}; filterRows($any(editorUtil).finalPacking)">clear</button></th>
          <th></th>
          <th><ngx-doc-form-texfield [value]="filterField?.id?.search || ''" (keyupChange)="filterField.id = { search: $event }; filterRows($any(editorUtil).finalPacking)" [styles]="{ width: '3rem' }"></ngx-doc-form-texfield></th>
          <th><ngx-doc-form-texfield [value]="filterField?.name?.search || ''" (keyupChange)="filterField.name = { search: $event }; filterRows($any(editorUtil).finalPacking)"></ngx-doc-form-texfield></th>
          <th><ngx-doc-form-texfield [value]="filterField?.pallet?.search || ''" (keyupChange)="filterField.pallet= { search: $event }; filterRows($any(editorUtil).finalPacking)"></ngx-doc-form-texfield></th>
          <th><ngx-doc-form-texfield [value]="filterField?.cartonBox?.search || ''" (keyupChange)="filterField.cartonBox = { search: $event }; filterRows($any(editorUtil).finalPacking)"></ngx-doc-form-texfield></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th colspan="2"></th>
          <th colspan="2"></th>
          <th colspan="2"></th>
          <th></th>
          <th></th>
          <th><ngx-doc-form-texfield [value]="filterField?.text?.search || ''"  (keyupChange)="filterField.text = { search: $event }; filterRows($any(editorUtil).finalPacking)" [styles]="{ width: '8rem' }"></ngx-doc-form-texfield></th>
          <th><ngx-doc-form-texfield [value]="filterField?.freeText?.search || ''"  (keyupChange)="filterField.freeText = { search: $event }; filterRows($any(editorUtil).finalPacking)"></ngx-doc-form-texfield></th>
        </tr>
        <ng-container *ngFor="let row of filteredRows; index as idx">
          <tr [ngStyle]="{ 'background-color': row.disabled ? '#e8e8e8' : null }">
            <td><button class="nrk-button" (click)="row.disabled = !row.disabled">{{row.disabled ? 'o' : 'x'}}</button></td>
            <td><button class="nrk-button" (click)="$any(editorUtil).addRow('finalPacking', row)">+</button></td>
            <td role="button" style="width:auto" (click)="moveDown($any(editorUtil).finalPacking, idx);filterRows($any(editorUtil).finalPacking)">▼</td>
            <td role="button" style="width:auto" (click)="moveUp($any(editorUtil).finalPacking, idx);filterRows($any(editorUtil).finalPacking)">▲</td>
  
            <!-- <td style="width:auto"><button *ngIf="$any(editorUtil).finalPacking.length > 1" class="nrk-button" (click)="$any(editorUtil).removeRow('finalPacking', idx)">-</button></td> -->
            <td><button *ngIf="$any(editorUtil).canRemove('finalPacking', row)" class="nrk-button" (click)="$any(editorUtil).removeRow('finalPacking', row)">-</button></td>
            <td><ngx-form-text [styles]="{'width':'5rem'}" [(value)]="row.id" [disabled]="!$any(editorUtil).canRemove('finalPacking', row)"></ngx-form-text></td>
            <td><ngx-form-text [styles]="{'width':'23rem'}" [(value)]="row.name" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-form-text></td>
            <td><ngx-doc-form-dropdown [(value)]="row.pallet" [options]="$any(editorUtil).palletOptions" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-dropdown></td>
            <td><ngx-doc-form-dropdown [(value)]="row.cartonBox" [options]="$any(editorUtil).boxOptions" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-dropdown></td>
            <td><ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.boxesPerLayer" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.layersPerPallet" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.multiplier" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-form-text></td>
            <td><ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.heightAdjustment" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-form-text></td>
            <td>
                <ngx-doc-form-checkbox [(value)]="row.temperatureSticker" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-checkbox>
            </td>
            <td>
                <ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.temperatureStickerWeight" [disabled]="row.disabled"></ngx-form-text>
            </td>
            <td>
              <ngx-doc-form-checkbox [(value)]="row.thermoShield" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-checkbox>
            </td>
            <td>
              <ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.thermoShieldWeight" [disabled]="row.disabled"></ngx-form-text>
            </td>
            <td>
                <ngx-doc-form-checkbox [(value)]="row.edgeProtection" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-checkbox>
            </td>
            <td>
              <ngx-form-text [styles]="{'width':'3rem'}" [(value)]="row.edgeProtectionWeight" [disabled]="row.disabled"></ngx-form-text>
            </td>
            <td>
              <div style="display:inline-block">
                <ngx-doc-form-checkbox [(value)]="row.relabelling" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-checkbox>
              </div>
            </td>
            <td>
                <ngx-doc-form-checkbox [(value)]="row.outsideLabel" (valueChange)="$any(editorUtil).generateFpdName(row)" [disabled]="row.id === 'FPD0' || row.disabled"></ngx-doc-form-checkbox>
            </td>
            <td style="width:auto"><ngx-form-text [styles]="{'width':'8rem'}" [(value)]="row.text" [disabled]="row.disabled"></ngx-form-text></td>
            <td style="width:auto"><ngx-form-text [styles]="{'width':'15rem'}" [(value)]="row.freetext" [disabled]="row.disabled"></ngx-form-text></td>
          </tr>
        </ng-container>
          <!-- <tr *ngFor="let row of $any(editorUtil).boxLayer; index as idx"> -->
            <!-- <td style="width:auto"><button class="nrk-button" (click)="$any(editorUtil).addRow('boxLayer', idx)">+</button></td> -->
            <!-- <td style="width:auto"><button *ngIf="$any(editorUtil).boxLayer.length > 1" class="nrk-button" (click)="$any(editorUtil).removeRow('boxLayer', idx)">-</button></td> -->
            <!-- <td><ngx-form-text [multiline]="1" [(value)]="row.pallet"></ngx-form-text></td> -->
            <!-- <td><ngx-form-text [multiline]="1" [(value)]="row.cartonBox"></ngx-form-text></td> -->
            <!-- <td><ngx-doc-form-dropdown [(value)]="row.pallet" [options]="palletOptions"></ngx-doc-form-dropdown></td> -->
            <!-- <td><ngx-doc-form-dropdown [(value)]="row.cartonBox" [options]="cartonBoxOptions"></ngx-doc-form-dropdown></td> -->
            <!-- <td><ngx-form-text [multiline]="1" [(value)]="row.boxesPerLayer"></ngx-form-text></td> -->
          <!-- </tr> -->
      </table>
      <br><br>
    </div>

  </div>

  <!-- ============================================== static texts ============================================ -->
  <div *ngIf="utilType == 'staticTexts'" class="section">

    <div *ngFor="let item of editorItems">
      <h4>{{item?.name}}</h4>
      <div *ngIf="item.id === 'inMailText'">Placeholder: &lt;invoice-number&gt;, &lt;customer-doc&gt;, &lt;issue-date&gt;, &lt;due-date&gt;, &lt;total-net&gt;</div>
      <div *ngIf="item.id === 'spoMailHeader'">Placeholder: &lt;contact-name&gt;, &lt;product-name&gt;, &lt;customer-code&gt;, &lt;customer-name&gt;, &lt;doc-code&gt;</div>
      <div *ngIf="item.id === 'ocMailHeader'">Placeholder: &lt;contact-name&gt;</div>
      <div *ngIf="item.id === 'orMailText'">Placeholder: &lt;responsible-name&gt;, &lt;issue-date&gt;, &lt;customer-name&gt;, &lt;customer-doc&gt;, &lt;quantity-and-unit&gt;, &lt;product-code&gt;, &lt;product-name&gt;, &lt;customer-code&gt;, &lt;line-crdd&gt;</div>
      <ngx-form-text *ngIf="item" [multiline]="1" [(value)]="item.data"></ngx-form-text>
      <br />
    </div>

  </div>

  <!-- ============================================ reports mailer ============================================ -->
  <div *ngIf="utilType == 'reportsMail'" class="section">

    <div>

      <div *ngIf="editorItems?.[0]" class="mb-4">
        <h4>List of Recipients</h4>
        <ngx-form-text [multiline]="1" [(value)]="editorItems[0].data"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[2]" class="mb-4">
        <h4>Subject</h4>
        <ngx-form-text [(value)]="editorItems[2].data" [disabled]="true"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[3]" class="mb-1">
        <h4>Mail Content</h4>
        <!-- <ngx-form-text [multiline]="1" [(value)]="editorItems?.[3].data"></ngx-form-text> -->
        <!-- <quill-editor [(ngModel)]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }"></quill-editor> -->
        <!-- <quill-editor #quillEditor [ngModel]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }" (ngModelChange)="setMailContent($event)"></quill-editor> -->
        <!-- <quill-editor [(ngModel)]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }"></quill-editor>
        <quill-view [content]="editorItems?.[3].data"></quill-view> -->
        <quill-editor #quill *ngIf="editorItems?.[3]?.data !== null" [(ngModel)]="editorItems[3].data" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)"></quill-editor>
      </div>

      <div class="mb-4">
        <button class="btn btn-info btn-md" (click)="openActionPointWin()">Open Action Point Editor</button>
        <div *ngIf="editorItems[9]?.data[0]" class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[9].data[0].sendActionpoints" label="Add actionpoints to weekly report"></ngx-doc-form-checkbox></div>
        <div *ngIf="editorItems[9]?.data[0]" class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[9].data[0].addInOrStockInfo" label="Add weekly IN/OR sum & current stock level"></ngx-doc-form-checkbox></div>
      </div>

      <div *ngIf="editorItems?.[4]?.data?.[0]" class="mb-4">
        <h4>Time to Send</h4>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].monday" label="Monday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].tuesday" label="Tuesday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].wednesday" label="Wednesday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].thursday" label="Thursday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].friday" label="Friday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].saturday" label="Saturday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].sunday" label="Sunday"></ngx-doc-form-checkbox></div>
        <br>
        Time (HH:MM):&nbsp;&nbsp;<ngx-doc-form-texfield [(value)]="editorItems[1].data"></ngx-doc-form-texfield>
      </div>

      <div *ngIf="editorItems?.[5]?.data?.[0]">
        <h4>Reports</h4>
        <ng-container *ngFor="let rep of reportNames">
          <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[5].data[0][rep.id]" [label]="rep.header"></ngx-doc-form-checkbox></div>
        </ng-container>
      </div>

      <br><br><br>

      <button class="btn btn-info btn-md mt-4" (click)="api.sendReports()">Send Weekly Reports</button>

      <br><br><br>

      <div *ngIf="$any(editorUtil).emailInfo">
        <h5>Last week IN in EUR</h5>
        <table style="margin-bottom:0.5rem">
          <tr>
            <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">BU</th>
            <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">EUR</th>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRVI</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekIN.nrvi | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRMM</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekIN.nrmm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRBM</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekIN.nrbm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">Energy Materials</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekIN.em | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
        </table>
        <br>
        <h5>Last week OR in EUR</h5>
        <table style="margin-bottom:0.5rem">
          <tr>
            <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">BU</th>
            <th style="border: 1px solid black; padding: 0.5rem; background-color: #ddd">EUR</th>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRVI</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekOR.nrvi | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRMM</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekOR.nrmm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">NRBM</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekOR.nrbm | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
          <tr>
            <td style="border: 1px solid black; padding: 0.5rem">Energy Materials</td>
            <td style="border: 1px solid black; padding: 0.5rem;text-align: right">{{$any(editorUtil).emailInfo.lastWeekOR.em | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}</td>
          </tr>
        </table>
        <br><br>
        Current stock level in EUR: {{$any(editorUtil).emailInfo.currentStockLevelEUR | currency : 'EUR' : 'symbol' : '1.2-2' : 'de'}}<br>
        Current stock level in USD: {{$any(editorUtil).emailInfo.currentStockLevelUSD | currency : 'USD' : 'symbol' : '1.2-2' : 'de'}}

      </div>
    </div>

  </div>
  
  <!-- ============================================ reports mailer 2 ============================================ -->
  <div *ngIf="utilType == 'reportsMail2'" class="section">

    <div>

      <div *ngIf="editorItems?.[0]" class="mb-4">
        <h4>List of Recipients</h4>
        <ngx-form-text [multiline]="1" [(value)]="editorItems[0].data"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[2]" class="mb-4">
        <h4>Subject</h4>
        <ngx-form-text [(value)]="editorItems[2].data" [disabled]="true"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[3]" class="mb-4">
        <h4>Mail Content</h4>
        <!-- <ngx-form-text [multiline]="1" [(value)]="editorItems?.[3].data"></ngx-form-text> -->
        <!-- <quill-editor [(ngModel)]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }"></quill-editor> -->
        <!-- <quill-editor #quillEditor [ngModel]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }" (ngModelChange)="setMailContent($event)"></quill-editor> -->
        <!-- <quill-editor [(ngModel)]="editorItems?.[3].data" [modules]="{ blotFormatter: {} }"></quill-editor>
        <quill-view [content]="editorItems?.[3].data"></quill-view> -->
        <quill-editor #quill *ngIf="editorItems?.[3]?.data !== null" [(ngModel)]="editorItems[3].data" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)"></quill-editor>
      </div>

      <div class="mb-4">
        <button class="btn btn-info btn-md" (click)="openActionPointWin('reportsMail2')">Open Action Point Editor</button>
        <div *ngIf="editorItems[9]?.data[0]" class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[9].data[0].sendActionpoints" label="Add actionpoints to weekly report"></ngx-doc-form-checkbox></div>
      </div>

      <div *ngIf="editorItems?.[4]?.data?.[0]" class="mb-4">
        <h4>Time to Send</h4>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].monday" label="Monday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].tuesday" label="Tuesday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].wednesday" label="Wednesday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].thursday" label="Thursday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].friday" label="Friday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].saturday" label="Saturday"></ngx-doc-form-checkbox></div>
        <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[4].data[0].sunday" label="Sunday"></ngx-doc-form-checkbox></div>
        <br>
        Time (HH:MM):&nbsp;&nbsp;<ngx-doc-form-texfield [(value)]="editorItems[1].data"></ngx-doc-form-texfield>
      </div>

      <div *ngIf="editorItems?.[5]?.data?.[0]">
        <h4>Reports</h4>
        <ng-container *ngFor="let rep of reportNames2">
          <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[5].data[0][rep.id]" [label]="rep.header"></ngx-doc-form-checkbox></div>
        </ng-container>
      </div>

      <br><br><br>

      <button class="btn btn-info btn-md mt-4" (click)="api.sendReports2()">Send Weekly Reports</button>

    </div>

  </div>
  
  <!-- ============================================ monthly reports mailer headquater ============================================ -->
  <div *ngIf="utilType == 'reportsMailHQ'" class="section">

    <div>

      <div *ngIf="editorItems?.[0]" class="mb-4">
        <h4>List of Recipients</h4>
        <ngx-form-text [multiline]="1" [(value)]="editorItems[0].data"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[2]" class="mb-4">
        <h4>Subject</h4>
        <ngx-form-text [(value)]="editorItems[2].data" [disabled]="true"></ngx-form-text>
      </div>

      <div *ngIf="editorItems?.[3]" class="mb-4">
        <h4>Mail Content</h4>
        <quill-editor #quill *ngIf="editorItems?.[3]?.data !== null" [(ngModel)]="editorItems[3].data" [modules]="quillModules" (onEditorCreated)="onEditorCreated($event)"></quill-editor>
      </div>

      <div *ngIf="editorItems?.[4]?.data?.[0]" class="mb-4">
        <h4>Time to Send (Last of Month)</h4>
        Time (HH:MM):&nbsp;&nbsp;<ngx-doc-form-texfield [(value)]="editorItems[1].data"></ngx-doc-form-texfield>
      </div>

      <div *ngIf="editorItems?.[5]?.data?.[0]">
        <h4>Reports</h4>
        <ng-container *ngFor="let rep of reportNamesHQ">
          <div class="mb-1"><ngx-doc-form-checkbox [(value)]="editorItems[5].data[0][rep.id]" [label]="rep.header"></ngx-doc-form-checkbox></div>
        </ng-container>
      </div>

      <br><br><br>

      <button class="btn btn-info btn-md mt-4" (click)="api.sendReportsHQ()">HQ: Send Monthly Reports</button>

    </div>

  </div>
  
</div>

<!-- <div>
  <div class="sidebar footer position-fixed" *ngIf="editorUtil.showFooter">
    <div class="row" style="display:flex;align-items:center;justify-content:center;">
      <button class="btn btn-primary btn-md" (click)="save()">Save</button>
    </div>
  </div>
</div> -->
<div style="position:fixed;right:4rem;top:5rem;padding:0.5rem;background-color:white;border-radius:10px">
  <button class="btn btn-primary btn-md" (click)="save()">Save</button>
</div>

</ngx-page-container>
</div>
</ng-sidebar-container>
